import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import AsyncStorage  from '@react-native-async-storage/async-storage';
import { SafeAreaView, StyleSheet, View, TextInput, ActivityIndicator, KeyboardAvoidingView, Platform, Modal } from 'react-native';
import { Button, Input, IntakeFormQuestion, Routes, Screen, Colors, Text } from '../components';
import { EventsUtils }        from '../utils';
import { WebView }            from 'react-native-webview';
import { config }             from '../../config';
import PetController          from '../controllers/petController';
import AuthController         from '../controllers/authController';
import ConsultationController from '../controllers/consultationController';
import UserController         from '../controllers/userController';
import Utility from '../controllers/utilitiesController';
import {
  ConsultationStartPets,
  ConsultationStartIntakeForm,
  ConsultationStartPayment,
  ConsultationStartProgressBar,
  ConsultationStartSelectType,
  ConsultationStartScheduleVideo
} from '../containers';
import { useNavigate, useSearchParams } from 'react-router-dom';

class ConsultationStartFlowScreen_Base extends Component {

  constructor(props) {
    super(props);

    this.state = {
      display_section: 'pets', // 'pets' 'intake_form' 'consultation_type' 'payment_selection' 'schedule_video'
      pets: [],
      care_consultation_id: '',
      practice_id: '',
      partner_id: '',
      care_form_session: {},
      intake_questions: [],
      flow_data: {},
      rechat_provider_id: props.provider_id,
      is_rechat: props.is_rechat ? props.is_rechat : false,
      error_message: '',
      intake_error_message: '',
      payment_display_section: 'loading_details', // 'prices' 'loading_details' 'processing_payment' 'subscription_exists' 'one_time_payment_complete'
      display_webview: false,
      webview_url: '',
      payment_intent_id: '',
      payment_btn_loading: false,
      payment_error_message: '',
      subscription_status: 'unknown',
      payment_status: 'unpaid'
    }
  }

  componentDidMount = async () => {
    let step              = this.props.step || '';
    let display_section   = step === 'ps' || step === 'pc' ? 'payment_selection' : '';
    let state_restore_str = await AsyncStorage.getItem('start_consultation_state');

    if (step && state_restore_str && Platform.OS === 'web') {
      let state_restore_obj = JSON.parse(state_restore_str);
      this.setState({ ...state_restore_obj });
    } else {
      this.setState({ loading_pets: true }, async () => {
        let response   = await PetController.getAllPets();
        let user       = await AuthController.getUser();
        let pets_array = await Utility.getPets();
        let user_id    = user && user.user_id ? user.user_id : '';
        let partner_id = await AsyncStorage.getItem('partner_id');

        let pet_consults    = await ConsultationController.getPetActiveConsultations({ partner_id: partner_id });
        let pet_consult_arr = pet_consults && pet_consults.success && pet_consults.data && pet_consults.data.care_consultation ? pet_consults.data.care_consultation : [];
        let pet_consult_obj = this.get_pet_consultation_object(pet_consult_arr);

        if(response.success) {
          this.setState({ loading_pets: false, user: user, user_id: user_id, pets: pets_array, pet_consult_count: pet_consult_obj })
        } else {
          this.setState({ loading_pets: false, user: user, user_id: user_id, pet_consult_count: pet_consult_obj })
        }
      });
    }
  }

  get_pet_consultation_object = (pet_consult_arr) => {
    let consults_array  = pet_consult_arr || [];
    let consults_object = {};

    consults_array.forEach((pet_consultation) => {
      if (pet_consultation && pet_consultation.patient_id) {
        consults_object[pet_consultation.patient_id] = {
          async_chat: pet_consultation.async_chat,
          chat: pet_consultation.chat,
          live_video: pet_consultation.live_video,
          video: pet_consultation.video,
        }
      }
    });

    return consults_object;
  }

  render_progress_bar = () => {
    let current_section  = this.state.display_section;
    let current_step_num = 1;
        current_step_num = current_section === 'intake_form'       ? 2 : current_step_num;
        current_step_num = current_section === 'payment_selection' ? 3 : current_step_num;
        current_step_num = current_section === 'consultation_type' ? 4 : current_step_num;

    if (current_section === 'schedule_video_dates' || current_section === 'schedule_video_confirm') {
      return null;
    }

    return <View>
      <ConsultationStartProgressBar
        total_steps={4}
        current_step={current_step_num}
      />
    </View>
  }

  render_pets_selection = () => {
    if (this.state.display_section !== 'pets') {
      return null;
    }

    return <View>
      <ConsultationStartPets
        navigation={this.props.navigation}
        pets={this.state.pets}
        pet_consults={this.state.pet_consult_count}
        selected_pet={this.state.selected_pet_id}
        loading_care_form={this.state.loading_care_form_session}
        continue_action={ async (selected_pet_id) => {

          this.setState({ loading_care_form_session: true, selected_pet_id: selected_pet_id }, async () => {

            let care_form_session = await this.create_new_care_form_session();
            let practice_id       = care_form_session && care_form_session.practice_id ? care_form_session.practice_id : '';
            let partner_id        = care_form_session && care_form_session.partner_id  ? care_form_session.partner_id  : '';
            let user              = this.state.user || {};
            let pets              = this.state.pets || [];
                user              = await AuthController.getUser();
            let user_id           = user && user.user_id ? user.user_id : '';

            let temp_data = {
              account_data: { user: user, pets: pets },
              patient_id: selected_pet_id,
              client_id: user_id,
              practice_id: practice_id,
              partner_id: partner_id
            }

            let intake_questions    = await ConsultationController.getIntakeQuestions(temp_data);
            let form_id_exists      = care_form_session && care_form_session._id ? true : false;
            let new_display_section = form_id_exists ? 'intake_form' : this.state.display_section;
            let error_message       = '';

            if (!form_id_exists) {
              error_message = 'Issue starting a Session. Try again by selecting a pet. If issue persists, Sign Out and Sign back in before retrying.';
            }

            this.setState({
              display_section: new_display_section,
              patient_id: selected_pet_id,
              partner_id: partner_id,
              practice_id: practice_id,
              care_form_session: care_form_session,
              intake_questions: intake_questions,
              flow_data: temp_data,
              loading_care_form_session: false,
              error_message: error_message,
            })
          });

        }}/>
    </View>
  }

  goBack = () => {
    if(Platform.OS === 'web') {
      this.props.navigate(-1);
    } else {
      this.props.navigation.goBack();
    }
  }

  render_intake_form = () => {
    if (this.state.display_section !== 'intake_form') {
      return null;
    }

    return <View>
      <ConsultationStartIntakeForm
        intake_questions={ this.state.intake_questions }
        error_message={ this.state.intake_error_message }
        continue_action={ async (intake_data) => {
          let continue_flow       = intake_data.proceed;
          let intake_responses_id = this.state.intake_response_id || '';
          let user                = await AuthController.getUser();
          let user_id             = user && user.user_id ? user.user_id : '';

          let intake_request_data = {
            client_id: user_id,
            category: intake_data.category,
            responses: intake_data.intake_responses,
            intake_responses_id: intake_responses_id,
          }

          let intake_submission_data = await ConsultationController.submitClientIntakeResponses(intake_request_data);

          let consultation_id    = intake_submission_data && intake_submission_data.consultation     && intake_submission_data.consultation._id     ? intake_submission_data.consultation._id     : '';
          let intake_response_id = intake_submission_data && intake_submission_data.intake_responses && intake_submission_data.intake_responses._id ? intake_submission_data.intake_responses._id : '';

              consultation_id    = consultation_id    ? consultation_id    : this.state.consultation_id;
              intake_response_id = intake_response_id ? intake_response_id : this.state.intake_response_id;

          let temp_form_data = {
            intake_responses: intake_data.intake_responses,
            triage_responses: intake_data.triage_responses,
            category: intake_data.category,
            completed_account_info: true,
            completed_triage: true,
            completed_intake_questions: continue_flow ? true : false,
            care_consultation_id: consultation_id,
            intake_responses_id: intake_response_id,
          }

          await this.update_care_form_session_in_db(temp_form_data);

          if (!consultation_id) {
            this.setState({ intake_error_message: 'Submission Failed. Restart from the previous step and try again.' });
          } else if (continue_flow) {
            let updated_flow_data = Object.assign({}, this.state.flow_data);
            updated_flow_data['consultation_id']    = consultation_id;
            updated_flow_data['intake_response_id'] = intake_response_id;
            updated_flow_data['category']           = intake_data.category;
            this.setState({
              display_section: 'payment_selection',
              intake_responses: intake_data.intake_responses,
              triage_responses: intake_data.triage_responses,
              category: intake_data.category,
              flow_data: updated_flow_data,
              consultation_id: consultation_id,
              intake_response_id: intake_response_id,
              intake_error_message: '',
            })
          } else {
            this.goBack()
          }
        }}/>
    </View>
  }

  render_payment_selection = () => {
    if (this.state.display_section !== 'payment_selection') {
      return null;
    }
    let care_consultation_id = this.state.consultation_id;
    let cancel_url           = '';
    let success_url          = '';

    let redirect_domain = config.app_domain;
    let platform_str    = 'Unspecified';
        platform_str    = Platform.OS === 'web'     ? 'Web Browser' : platform_str;
        platform_str    = Platform.OS === 'ios'     ? 'iOS App'     : platform_str;
        platform_str    = Platform.OS === 'android' ? 'Android App' : platform_str;

    if(Platform.OS === 'web') {
      cancel_url  = `${redirect_domain}/consultation_start_flow?stpe=pc`;
      success_url = `${redirect_domain}/consultation_start_flow?stpe=ps`;
    } else {
      cancel_url  = `${redirect_domain}/empty_page?content=Payment Cancelled`;
      success_url = `${redirect_domain}/empty_page?content=Payment Successful`;
    }

    return <View style={{ }}>
      <ConsultationStartPayment
        loading={this.state.payment_btn_loading}
        error_message={this.state.payment_error_message}
        display_section={this.state.payment_display_section}
        proceed_action={ () => { this.setState({ display_section: 'consultation_type' }) }}
        payment_status_action={ () => { this.check_payment_verified() }}
        open_single_payment_modal={ async (price_id) => {
          this.setState({ payment_btn_loading: true, payment_error_message: '' });

          let email          = await AsyncStorage.getItem('email');
          let partner_id     = await AsyncStorage.getItem('partner_id');
          let stripe_url_res = await AuthController.createSinglePaymentIntentCheckout({ price_id, partner_id, cancel_url, success_url, email, platform: platform_str, care_consultation_id: care_consultation_id });

          if(stripe_url_res.success && stripe_url_res.url) {
            if (Platform.OS === 'web') {
              this.setState({ payment_display_section: 'processing_payment', payment_btn_loading: false });
              let state_restore_str = JSON.stringify(this.state);
              await AsyncStorage.setItem('start_consultation_state', state_restore_str);
              window.location.replace(stripe_url_res.url);
            } else {
              this.setState({ display_webview: true, webview_url: stripe_url_res.url, payment_display_section: 'processing_payment', payment_btn_loading: false });
            }
          } else {
            let error_message = stripe_url_res && stripe_url_res.error ? stripe_url_res.error : '';
            this.setState({ payment_btn_loading: false, payment_error_message: error_message });
          }
        }}
        open_subscription_payment_modal={ async (price_id) => {
          this.setState({ payment_btn_loading: true, payment_error_message: '' });

          let email          = await AsyncStorage.getItem('email');
          let partner_id     = await AsyncStorage.getItem('partner_id');
          let stripe_url_res = await AuthController.createCheckoutSession({ price_id, partner_id, cancel_url, success_url, email, platform: platform_str });

          if(stripe_url_res.success && stripe_url_res.url) {
            if (Platform.OS === 'web') {
              this.setState({ payment_display_section: 'processing_payment', payment_btn_loading: false });
              let state_restore_str = JSON.stringify(this.state);
              await AsyncStorage.setItem('start_consultation_state', state_restore_str);
              window.location.replace(stripe_url_res.url);
            } else {
              this.setState({ display_webview: true, webview_url: stripe_url_res.url, payment_display_section: 'processing_payment', payment_btn_loading: false });
            }
          } else {
            let error_message = stripe_url_res && stripe_url_res.error ? stripe_url_res.error : '';
            this.setState({ payment_btn_loading: false, payment_error_message: error_message });
          }
        }}
        set_display_section={ (display_section) => { this.setState({ payment_display_section: display_section }) }}
      />
    </View>
  }

  render_select_consultation = () => {
    if (this.state.display_section !== 'consultation_type') {
      return null;
    }

    let practice_id = this.state.practice_id || '60bf84e240ddf53c32c81b00';
    let partner_id  = this.state.partner_id  || '61095a8be631947a739a21c7';

    let care_consultation_id = this.state.consultation_id;

    return <View>
      <ConsultationStartSelectType
        category={this.state.category}
        client_id={this.state.user_id}
        patient_id={this.state.patient_id}
        partner_id={partner_id}
        practice_id={practice_id}
        is_rechat={this.state.is_rechat}
        pet_consults={this.state.pet_consult_count}
        rechat_provider_id={this.state.rechat_provider_id}
        care_consultation_id={care_consultation_id}
        success_chat_action={ (care_consultation_id) => {
          if(Platform.OS === 'web') {
            let path = `${Routes.CONSULTATION_CHAT}?consultation_id=${care_consultation_id}&back_to_home=true`;
            this.props.navigate(path);
          } else {
            this.props.navigation.push(Routes.CONSULTATION_CHAT, {consultation_id: care_consultation_id, back_to_home: true})
          }
        }}
        schedule_video_action={ () => {
          this.setState({ display_section: 'schedule_video_dates' })
        }}

        live_video_action={ (care_consultation_id) => {
          if(Platform.OS === 'web') {
            let path = `${Routes.CONSULTATION_LIVE_VIDEO}?consultation_id=${care_consultation_id}&back_to_home=true`
            this.props.navigate(path);
          } else {
            this.props.navigate(Routes.CONSULTATION_LIVE_VIDEO, { consultation_id: care_consultation_id, back_to_home: true })
          }
        }}
        />
    </View>
  }

  render_schedule_video = () => {
    if (this.state.display_section !== 'schedule_video_dates' && this.state.display_section !== 'schedule_video_confirm') {
      return null;
    }

    let practice_id = this.state.practice_id || '60aee21ead3ef665916e1c7f';
    let partner_id  = this.state.partner_id  || '6113b6b59bd2a4783a4bc57f';

    return <View>
      <ConsultationStartScheduleVideo
        practice_id={practice_id}
        partner_id={partner_id}
        loading_create_consultation={this.state.loading_create_consultation}
        schedule_display_section={ this.state.display_section }
        display_change_action={ (section_name) => { this.setState({ display_section: section_name }) }}
        booking_confirmation_action={ async (availability_slot_id) => {

          let flow_data = this.state.flow_data;

          let request_data = {
            client_id: flow_data.client_id,
            patient_id: flow_data.patient_id,
            availability_slot_id: availability_slot_id,
            practice_id: flow_data.practice_id,
            partner_id: flow_data.partner_id,
            category: flow_data.category,
            care_consultation_id: flow_data.consultation_id,
          }

          this.setState({ loading_create_consultation: true}, async () => {
            let schedule_video_response = await ConsultationController.scheduleVideoConsulation(request_data);

            if (schedule_video_response.success) {
              if(Platform.OS === 'web') {
                let path = `${Routes.CONSULTATION_VIDEO_APPOINTMENT}?consultation_id=${flow_data.consultation_id}&back_to_home=true`
                this.props.navigate(path);
              } else {
                this.props.navigate(Routes.CONSULTATION_VIDEO_APPOINTMENT, { consultation_id: flow_data.consultation_id, back_to_home: true })
              }
            }
            this.setState({ loading_create_consultation: false })
          });

        }}
      />
    </View>
  }

  render_error_message = () => {
    let error_message = this.state.error_message;

    if (error_message) {
      return <View style={{ padding: 10 }}>
        <View style={{ backgroundColor: Colors.RED, padding: 15, borderRadius: 12 }}>
          <Text style={{ color: 'white', fontWeight: '500' }}>{ error_message }</Text>
        </View>
      </View>
    }
  }

  render() {
    let header_title = this.get_header_title();

    return (
      <Screen navigation={this.props.navigation} title={header_title} left_action={this.back_button_action} scroll={true} auth={true} bg_image={true}>
        { this.render_progress_bar()        }
        { this.render_error_message()       }
        { this.render_pets_selection()      }
        { this.render_intake_form()         }
        { this.render_payment_selection()   }
        { this.render_select_consultation() }
        { this.render_schedule_video()      }
        { this.render_webview_modal()       }
      </Screen>
    );
  }

  render_webview_modal = () => {
    return <Modal
      animationType="slide"
      transparent={true}
      visible={ this.state.display_webview }
      onRequestClose={() => {
        this.setState({ display_webview: false, webview_url: '' })
      }}>
        <Screen navigation={this.props.navigation} title={'Payment Details'} right_action={ () => { this.payment_modal_closed() }} modal={true}>
          <WebView
            enableApplePay={true}
            style={styles.pdf_view_container}
            source={{ uri: this.state.webview_url }}
          />
        </Screen>
    </Modal>
  }

  payment_modal_closed = () => {
    this.check_payment_verified();
  }

  check_payment_verified = async () => {
    let partner_id              = await AsyncStorage.getItem('partner_id');
    let check_intent_response   = await AuthController.checkPaymentIntentStatus({ care_consultation_id: this.state.consultation_id });
    let check_subscription_res  = await UserController.checkSubscription({ partner_id });

    let has_active_subscription = check_subscription_res && check_subscription_res.success && check_subscription_res.has_active_subscription ? true : false;
    let payment_intent_verified = check_intent_response  && check_intent_response.success  && check_intent_response.payment_added            ? true : false;

    if ((this.state.subscription_status === 'unknown' || this.state.subscription_status === 'inactive') && has_active_subscription) {
      EventsUtils.log_facebook_event('Subscribe')
    }

    if (has_active_subscription) {
      this.setState({ payment_display_section: 'subscription_exists', subscription_status: 'active', display_webview: false, webview_url: '' });
      return;
    }

    if (this.state.payment_status === 'unpaid' && payment_intent_verified) {
      EventsUtils.log_facebook_event('Purchase')
    }

    if (payment_intent_verified) {
      this.setState({ payment_display_section: 'one_time_payment_complete', payment_status: 'paid', display_webview: false, webview_url: '' })
      return;
    }

    this.setState({ payment_display_section: 'prices', subscription_status: 'inactive', display_webview: false, webview_url: '' });
  }

  get_header_title = () => {
    let current_display_section = this.state.display_section;

    let title = current_display_section === 'pets'        ? 'Select a Pet'      : 'Starting Your Session';
        title = current_display_section === 'intake_form' ? 'Let’s get started' : title;

    return title;
  }

  back_button_action = () => {
    let current_display_section = this.state.display_section;
    let is_web                  = Platform.OS === 'web';

    let new_display_section = current_display_section === 'intake_form'            ? 'pets'        : new_display_section;
        new_display_section = current_display_section === 'consultation_type'      ? 'payment_selection' : new_display_section;
        new_display_section = current_display_section === 'schedule_video_dates'   ? 'consultation_type' : new_display_section;
        new_display_section = current_display_section === 'schedule_video_confirm' ? 'schedule_video_dates' : new_display_section;
        new_display_section = current_display_section === 'payment_selection'      ? 'intake_form' : new_display_section;

    if (is_web && (current_display_section === 'payment_selection' || current_display_section === 'consultation_type')) {
      this.props.navigate(Routes.HOME)
    }

    if (current_display_section === 'pets') {
      this.goBack();
    } else {
      this.setState({ display_section: new_display_section, intake_error_message: '' })
    }
  }

  create_new_care_form_session = async () => {
    let partner_code     = await AsyncStorage.getItem('partner_code');
    let form_request_obj = {
      partner_code: partner_code,
    }
    return await ConsultationController.createCareFormSession(form_request_obj);
  }

  update_care_form_session_in_db = async (update_data) => {
    let care_form_session_id = this.state.care_form_session && this.state.care_form_session._id ? this.state.care_form_session._id : '';

    let request_object = {
      form_session_id: care_form_session_id,
      session_data: update_data,
    }

    let updated_care_form = await ConsultationController.updateCareFormSession(request_object);
  }

}

function ConsultationStartFlowScreen(props) {
  if(Platform.OS === 'web') {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    let is_rechat = searchParams.get('consultation_id');
    let step      = searchParams.get('stpe');
    return  <ConsultationStartFlowScreen_Base {...props} step={step} is_rechat={is_rechat} navigate={navigate} />
  } else {
    let params = props.route.params;
    let is_rechat   = params && params.is_rechat;
    let provider_id = params && params.provider_id;
    return  <ConsultationStartFlowScreen_Base {...props} provider_id={provider_id} is_rechat={is_rechat} navigate={props.navigation.push}  />
  }
}

const styles = StyleSheet.create({

});

export default ConsultationStartFlowScreen
